import React from 'react';
// Modules
import Container from 'react-bootstrap/Container';
// Context
import { LogsDataProvider } from '../../context/LogsContext';
// Components
import PageTitle from '../../components/header/PageTitle';
import LogList from './components/LogList';
import LogFilters from './components/LogFilters';

export default function ServicesPlusLogs() {
  return (
    <Container fluid className="container--width">
      <PageTitle titleText="Pedidos de subscrição e Gestão de pagamentos" />
      <LogsDataProvider>
        <LogFilters />
        <LogList />
      </LogsDataProvider>
    </Container>
  );
}
